import { jsonGet } from './external/components/ajax';
import { API_REFERENCE } from './external/utilities/constant_api';
import {
  disabledArrowsAccessibility,
  nextPrevSelectors
} from './external/utilities/utility';

var $ajaxCallEvent = true;
ACC.product = {
  _autoload: [
    'bindToAddToCartForm',
    'bindToAddToCartFormPopUp',
    'enableStorePickupButton',
    'enableVariantSelectors',
    'bindFacets'
  ],

  bindFacets: function() {
    $(document).on('click', '.js-show-facets', function(e) {
      e.preventDefault();
      var selectRefinementsTitle = $(this).data('selectRefinementsTitle');
      ACC.colorbox.open(selectRefinementsTitle, {
        href: '.js-product-facet',
        inline: true,
        width: '480px',
        onComplete: function() {
          $(document).on('click', '.js-product-facet .js-facet-name', function(
            e
          ) {
            e.preventDefault();
            $('.js-product-facet  .js-facet').removeClass('active');
            $(this)
              .parents('.js-facet')
              .addClass('active');
            $.colorbox.resize();
          });
        },
        onClosed: function() {
          $(document).off('click', '.js-product-facet .js-facet-name');
        }
      });
    });
    if (!$('.product__listing.product__grid').length) {
      var $availabilityProduct = $('.product-availability-col__div-w-100');
      if ($availabilityProduct.length) {
        $(
          '.product-availability-col__div--outOfStock, .product-availability-col__div--inStock'
        )
          .parents('.product-availability-row')
          .addClass('product-availability-row__align');
      }
    }
  },

  enableAddToCartButton: function() {
    $('.js-enable-btn').each(function() {
      if (
        !($(this).hasClass('outOfStock') || $(this).hasClass('out-of-stock'))
      ) {
        $(this).prop('disabled', false);
      }
    });
  },

  triggerSlider: function() {
    var numberofCarouselItem = 3;
    var length = 0;
    $.fn.chunk = function chunk(size) {
      var arr = [];
      length += this.length;
      for (var i = 0; i < this.length; i += size) {
        arr.push(this.slice(i, i + size));
      }

      return this.pushStack(arr, 'chunk', size);
    };

    $('.carousel-mobile > .item')
      .chunk(numberofCarouselItem)
      .wrap('<div class="carousel-slide slide row"></div>');

    function resizeRelatedCarousel() {
      var carouselOutterWidth = $('.-related-product-popup')
        .find('.carousel-mobile-wrapper')
        .innerWidth();
      var newCarouselWidth = ''.concat(carouselOutterWidth, 'px');
      $('.carousel-slide').css({
        'min-width': newCarouselWidth
      });
    }

    function sliderLoaded(slider) {
      $('.bx-clone *').attr('tabindex', '-1');
      $(slider)
        .find('.slide')
        .eq(0)
        .addClass('current');
      $(slider)
        .find('.slide')
        .not('.current')
        .find('*')
        .attr('tabindex', '-1');
      $(slider)
        .find('.current')
        .find('a, button')
        .attr('tabindex', '0');
      $(slider)
        .find('.bx-prev')
        .attr('tabindex', '0');
      $(slider)
        .find('.bx-next')
        .attr('tabindex', '0');
      resizeRelatedCarousel();
      if ($('.add_to_cart_form_popup').length) {
        $(document).on(
          'click',
          '.product-btn-new',
          ACC.product.bindToAddToCartFormPopUp
        );
      }
      if (screen.width < 768) {
        setTimeout(function() {
          $('.-related-product-popup')
            .find('.bxslider-carousel__product-icon')
            .hide();
        }, 10);
      }
    }

    function slideBefore(slider, curSlideIndex) {
      $(slider)
        .find('.slide')
        .removeClass('current');
      $(slider)
        .find('.slide')
        .not('.current')
        .find('*')
        .attr('tabindex', '-1');
      $(slider)
        .find('.slide:not(.bx-clone)')
        .eq(curSlideIndex)
        .addClass('current');
      $(slider)
        .find('.current')
        .find('a, button')
        .attr('tabindex', '0');
    }

    function SlideAfter(slider) {
      disabledArrowsAccessibility(slider);
      $(slider)
        .find('.slide')
        .not('.current')
        .find('*')
        .attr('tabindex', '-1');
      $(slider)
        .find('.current')
        .find('a, button')
        .attr('tabindex', '0');
    }

    var sliders = $('.bxslider');
    sliders.each(function(index, element) {
      var options = {
        minSlides: 1,
        maxSlides: 1,
        slideWidth: 900,
        slideMargin: 10,
        responsive: true,
        hideControlOnEnd: true,
        infiniteLoop: false,
        onSliderLoad: sliderLoaded(element),
        onSlideBefore: function onSlideBefore($slideElm, oldIndex, newIndex) {
          slideBefore(element, newIndex);
          $slideElm.attr('data-curSlide', newIndex);
        },
        onSlideAfter: () => {
          SlideAfter(element);
        }
      };

      if ($(element).find('.slide').length === 1) {
        options.pager = false;
      }

      if (length < 4) {
        options.touchEnabled = false;
        options.controls = false;
      }

      if (window.innerWidth >= 768) {
        if ($(element).hasClass('minicart')) {
          nextPrevSelectors('minicart', options);
        }
      }

      if ($(element).hasClass('minicart-carousel')) {
        $(element).bxSlider(options);
        const carouselImgs = $('.carousel-slide.current').find(
          'img:not([src=""])'
        );
        carouselImgs.on('load', () => {
          disabledArrowsAccessibility(element);
        });
      }
    });
  },

  enableVariantSelectors: function() {
    $('.variant-select').prop('disabled', false);
  },
  bindToAddToCartFormPopUp: function() {
    var addToCartFormPopUp = $('.add_to_cart_form_popup');
    addToCartFormPopUp.ajaxForm({
      cache: false,
      beforeSubmit: ACC.product.showRequest,
      success: ACC.product.displayAddToCartPopup
    });
  },

  bindToAddToCartForm: function() {
    var addToCartForm = $('.add_to_cart_form');
    addToCartForm.ajaxForm({
      beforeSubmit: ACC.product.showRequest,
      success: ACC.product.displayAddToCartPopup
    });
  },
  showRequest: function(arr, $form, options) {
    if ($ajaxCallEvent) {
      $ajaxCallEvent = false;
      return true;
    }
    return false;
  },

  bindToAddToCartStorePickUpForm: function() {
    var addToCartStorePickUpForm = $('#colorbox #add_to_cart_storepickup_form');
    addToCartStorePickUpForm.ajaxForm({
      success: ACC.product.displayAddToCartPopup
    });
  },

  enableStorePickupButton: function() {
    $('.js-pickup-in-store-button').prop('disabled', false);
  },

  bindCartUpdateQuantity: function(quantity) {
    const updateQtyUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.miniCart.updateMinicartQuantity}${quantity}`;
    jsonGet(updateQtyUrl).then(jsonData => {
      $('.nav-cart .js-mini-cart-count')
        .find('.badge')
        .text(jsonData.miniCartCount);
    });
  },

  displayAddToCartPopup: function(cartResult, statusText, xhr, formElement) {
    $ajaxCallEvent = true;
    $('#addToCartLayer').remove();
    ACC.product.bindCartUpdateQuantity(cartResult.quantity);
    var titleHeader = $('#addToCartTitle').html();

    var cboxOptions = {
      maxWidthLg: '900px',
      maxHeightLg: '800px',
      maxWidthMd: '766px',
      maxHeightMd: '529px',
      maxWidthSm: 'auto',
      maxHeightSm: 'auto'
    };

    function checkWidth() {
      if (window.innerWidth >= 992) {
        return cboxOptions.maxWidthLg;
      } else if (window.innerWidth >= 768 && window.innerWidth < 992) {
        return cboxOptions.maxWidthMd;
      } else {
        return cboxOptions.maxWidthSm;
      }
    }

    function checkHeight() {
      if (window.innerHeight >= 992) {
        return cboxOptions.maxHeightLg;
      } else if (window.innerHeight >= 768 && window.innerHeight < 992) {
        return cboxOptions.maxHeightMd;
      } else {
        return cboxOptions.maxHeightSm;
      }
    }

    if(cartResult.originalProduct != undefined && cartResult.originalProduct != null){
      ACC.colorbox.open('', {
        html: cartResult.forceFlipModalLayer,
        onLoad: $('#cboxOverlay').css('position', 'fixed'),
        width: checkWidth(),
        height: checkHeight(),
        className: 'force-flip-modal',
        onComplete: function(){
          let forceFlipModalLayer = $('#forceFlipModalLayer');
          let headerText = forceFlipModalLayer.find('.headerText').html();
          let formatedHeaderText = headerText.replace('{0}',cartResult.originalProduct.productCode).replace('{1}', cartResult.replacementProduct.productCode);
          forceFlipModalLayer.find('.headerText').html(formatedHeaderText);

          //Both side data population
          forceFlipModalLayer
            .find('.original-item .product-code')
            .html(cartResult.originalProduct.productCode);
          forceFlipModalLayer
            .find('.original-item .product-name')
            .html(cartResult.originalProduct.productName);
          forceFlipModalLayer
            .find('.replacement-item .product-code')
            .html(cartResult.replacementProduct.productCode);
          forceFlipModalLayer
            .find('.replacement-item .product-name')
            .html(cartResult.replacementProduct.productName);
        },
        onClosed : function(){
          addToCartModal()
        }
      });
    }
    else {
      addToCartModal()
    }
    function addToCartModal(){
      ACC.colorbox.open('', {
        html: cartResult.addToCartLayer,
        onLoad: $('#cboxOverlay').css('position', 'fixed'),
        width: checkWidth(),
        height: checkHeight(),
        className: 'add-to-cart-modal'
      });
    }

    var productCode = $('[name=productCodePost]', formElement).val();
    var quantityField = $('[name=qty]', formElement).val();

    var quantity = 1;
    if (quantityField !== undefined) {
      quantity = quantityField;
    }

    var cartAnalyticsData = cartResult.cartAnalyticsData;

    var cartData = {
      cartCode: cartAnalyticsData.cartCode,
      productCode: productCode,
      quantity: quantity,
      productPrice: cartAnalyticsData.productPostPrice,
      productName: cartAnalyticsData.productName,
      categories: cartAnalyticsData.categories
    };

    ACC.product.triggerSlider();

    $(window).resize(function() {
      $.colorbox.resize({
        width: checkWidth(),
        height: checkHeight()
      });
      ACC.utility.setEllipsis(
        $(
          '.cart-popup .product-section-related-similar span.product-heading-text__link'
        )
      );
    });

    ACC.track.trackAddToCart(productCode, quantity, cartData);
    ACC.utility.setEllipsis(
      $(
        '.cart-popup .product-section-related-similar span.product-heading-text__link'
      )
    );
    $('[data-toggle="tooltip"]').tooltip();
  },

  displayLoginPopup: function() {
    ACC.colorbox.close();
    setTimeout(function() {
      $('.header-signin')[0].click();
    }, 500);
  },

  stopAddToCart: function(e) {
    e.preventDefault();
  }
};

$(document).ready(function() {
  ACC.product.enableAddToCartButton();
  $(document).on(
    'click',
    '.cart-popup__signin_message',
    ACC.product.displayLoginPopup
  );
  $(document).on('click', '.product-btn-disabled', ACC.product.stopAddToCart);
  $(document).on('click', '.cart-popup__continue, .force-flip__continue', function(e) {
    e.preventDefault();
    ACC.colorbox.close();
  });
  ACC.utility.setEllipsis(
    $('.product__listing .product-heading-text .product-heading-text__link')
  );
});
